module.exports = __webpack_public_path__ + "static/img/product1back.be42eda5.jpg";